// src/hooks/useLayoutConfig.ts
import { useLocation, matchPath } from "react-router-dom";
import { layoutConfigMap } from "../utils/layoutConfig";

export function useLayoutConfig() {
  const location = useLocation();
  const path = location.pathname;
  for (const routePattern in layoutConfigMap) {
    if (matchPath({ path: routePattern, end: false }, path)) {
      return layoutConfigMap[routePattern];
    }
  }

  return {}; // fallback/default
}
